module.exports = __webpack_public_path__ + "img/momo_home_bg_2.f1a1236f.png";